<template>
  <div>
    <div class="top-container">
      <div class="top-table">
        <router-link to="/" class="sgnlogo-table"><img src="../../assets/img/sgn-logo.png"></router-link>
        <!-- <div class="top_change">
          <div class="top_change_show"
            @mouseover="changeMouseover"
            @mouseout="changeMouseout"
          >
            <img class="top_change_pic" src="../../assets/img/icon_company@2x.png" alt="">
            <span class="top_change_text">{{ localHeadOffice == 1 ? '本集团' : '本公司' }}</span>
            <div class="arrow"></div>
          </div>
          <div class="top_change_hide"
            v-show="changeIsHover"
            @mouseover="changeMouseover"
            @mouseout="changeMouseout"
          >
            <div class="top_change_item"><a @click="topChangeClick(true)" href="javascript:;">本集团</a></div>
            <div class="top_change_item"><a @click="topChangeClick(false)" href="javascript:;">本公司</a></div>
          </div>
        </div> -->
        <div class="top_change_show" style="background: #fff;"></div>
        <div class="top_btn">
          <a href="javascript:;" v-for="item in navList" :class="{'cur': item.isCur}" @click="pageChange(item)" >{{item.name}}</a>
        </div>
        <div class="top_login">
          <div class="top-logi-btn" v-show="!isLogin"><a href="javascript:;" @click="lBoxShowChange(true)" class="">登录</a></div>
          <div class="head-table" v-show="isLogin">
            <div class="head-head"
              @mouseover="mouseover"
              @mouseout="mouseout"
            >
              <a href="javascript:;">
                <img :src="storeUserimg">
              </a>
            </div>
          </div>
          <div class="head-content"
            v-show="isHover"
            @mouseover="mouseover"
            @mouseout="mouseout"
          >
            <div class="head-content-title">
              <div class="head-content-title-big">{{realName}}</div>
              <div class="head-content-title-small">{{department}}</div>
            </div>
            <div class="head-grzx" ><a @click="toAcc" href="javascript:;">个人中心</a></div>
            <div class="head-tc"><a href="javascript:;" @click="exit">退出登录</a></div>
          </div>
        </div>
      </div>
    </div>

    <div style="min-height: 500px;">
      <router-view v-if="isRouterAlive"></router-view>
    </div>

		<!---->
		<div class="footer-container">
			<div class="footer-table">
				<span class="footer-name">友情链接：</span>
        <a v-for="(item,index) in linkList" :key="item.title" :href="item.link" target="_blank" class="footer-left">{{item.title}}</a>
				<div class="footer-phone">
          <!-- <img src="../../assets/img/jwa.png" class="foote-icp"> -->
          客服电话：18611131433&#12288;&#12288;&#12288;&#12288;京ICP备 10005032号&#12288;&#12288;&#12288;&#12288;Copyright © 中国储备粮管理集团有限公司   All Rights Reserved
        </div>
        <!-- <div class="footer-phone">本网站由北京中公教育科技有限公司提供技术支持</div> -->
			</div>
		</div>
		<div class="bgtable" v-show="loginShow">
			<div class="bglogin">
				<a href="javascript:;" class="bgligin-close"  @click="lBoxShowChange(false)">
          <img src="../../assets/img/icon-close.png">
        </a>
				<div class="bglogin-title">用户登录</div>
				<div class="bglogin-name"><input type="text" v-model="username" class="bglogin-input" placeholder="请输入手机号"></div>
				<div class="bglogin-name"><input type="password" v-model="password" class="bglogin-input" placeholder="请输入密码"></div>
				<div class="bglogin-btn"><a href="javascript:;" @click="toLogin">登录</a></div>
				<div class="login-btn-password"><a href="javascript:;" @click="toForget" >忘记密码</a></div>
			</div>
		</div>
    <Labels></Labels>
  </div>
</template>

<script>
import '../../assets/css/index.css'
import {ApiLogin, ApiGetLinks, ApiPointsOrder, ApiGetCompanyInfo, ApiGetLoginInfoByCode} from '../../net/home/index.js'
import {hex_sha1} from '../../assets/js/hmac-sha1.js'
import {phoneFun, checkMobile, setCookie, getCookie, removeCookie} from '../../untils/common.js'
import store from '../../vuex/store.js'
import Labels from '../../common/lables.vue'
export default {
  data: function () {
    return {
      realName: '',
      department: '',
      userImage: 'http://statics.sgn.7east.cn/photo/20201207172318.png',
      username: '', // 手机号
      password: '',
      navList: [
        {
          name: '首页',
          path: '/',
          isCur: false
        },{
          name: '全部课程',
          path: '/AllCourse',
          isCur: false
        },{
          name: '重点课程',
          path: '/ICourse',
          isCur: false
        },{
          name: '直播课程',
          path: '/LiveCourse',
          isCur: false
        },
        {
          name: '电子书',
          path: '/BookCourse',
          isCur: false
        },
        // {
        //   name: '我的班级',
        //   path: '/MyClass',
        //   isCur: false
        // },
        {
          name: '我的社区',
          path: '/Community',
          isCur: false
        },{
          name: '我的发现',
          path: '/MyFind',
          isCur: false
        }
      ],
      linkList:[],
      loginBoxShow: false,
      isHover: false,
      hoverTimer: null,
      changeIsHover: false,
      changeHoveTimee: null,
      localHeadOffice: 1,
      showLables: false,
      isRouterAlive: true,
      userCode: '' //用于免登录
    }
  },
  store,
  computed: {
    isLogin: function () {
      return this.$store.state.isLogin
    },
    loginShow: function () {
      return this.$store.state.loginShow
    },
    storeUserimg: function () {
      return this.$store.state.userImage
    },
    pointsDetailId: function () {
      return this.$store.state.pointsDetailId
    }
   },
  components: {
    Labels
  },
  methods:{
    getLinks: function () {
      ApiGetLinks().then(res=>{
        if (res.code == 200) {
          this.linkList = res.value.details
        }
       // console.log('课程6要素', res)
      })
    },
    pageChange: function (item) {
      if(item.name == '我的班级' && !this.$store.state.isLogin){
        this.$store.commit('showLogin', true)
        return
      }
      if(item.path == '/Community' && !this.$store.state.isLogin){
        this.$store.commit('showLogin', true)
        return
      }
      if(item.path == '/MyFind' && !this.$store.state.isLogin){
        this.$store.commit('showLogin', true)
        return
      }
      this.navList = this.navList.map(nav=>{
        return {...nav, isCur: item.path == nav.path}
      })
      this.$router.push(item.path)
    },
    toAcc: function () {
      this.navList = this.navList.map(nav=>{
        return {...nav, isCur: false}
      })
      this.$router.push('/Accound')

    },
    mouseover: function () {
      clearTimeout(this.hoverTimer)
      this.isHover = true
    },
    mouseout: function () {
      clearTimeout(this.hoverTimer)
      this.hoverTimer = setTimeout(()=>{
        this.isHover = false
      },300)
    },
    changeMouseover: function () {
      clearTimeout(this.changeHoverTimer)
      this.changeIsHover = true
    },
    changeMouseout: function () {
      clearTimeout(this.changeHoverTimer)
      this.changeHoverTimer = setTimeout(()=>{
        this.changeIsHover = false
      },300)
    },
    topChangeClick: function (br) { // br 总公司true 分公司false
      if (!this.isLogin) {
        this.$message({
          message: '请登陆后使用',
          type: 'warning'
        })
        return
      }
      ApiGetCompanyInfo().then(res => {
        // console.log('res', res)
        if (res.code == 200) {
          if (br) { // 切换至总公司
            if (this.localHeadOffice == 1) { return }
            // setCookie('companyInfo', JSON.stringify(res.value))
            setCookie('headOffice', res.value.headOffice)
            this.localHeadOffice = res.value.headOffice
            this.changeRefresh()
          } else { // 切换至分公司
            if (!res.value.openClass) {
              this.$message({
                message: '该账号未开通分学堂',
                type: 'warning'
              })
              return
            }
            if (this.localHeadOffice == res.value.branchOffice) { return }
            // setCookie('companyInfo', JSON.stringify(res.value))
            setCookie('headOffice', res.value.branchOffice)
            this.localHeadOffice = res.value.branchOffice
            this.changeRefresh()
          }
        }
      })
    },
    changeRefresh: function () {
      this.getLinks()
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    lBoxShowChange: function (br) {
      // this.loginBoxShow = br
      this.$store.commit('showLogin', br)
    },
    checkLogin: function () {
      if (!phoneFun(this.username)) {
        this.$message({
          message: '手机号码格式有误',
          type: 'warning'
        })
        return false
      }

      if (!checkMobile(this.password)) {
        this.$message({
          message: '密码格式有误',
          type: 'warning'
        })
        return false
      }

      return true
    },
    toLogin: function () {
      if (!this.checkLogin()) {return}
      const prames = {
        username: this.username,
        password: hex_sha1(`${this.password}sinograin`)
      }
      ApiLogin(prames).then(res=>{
        if (res.code == 200) {
          setCookie('user', JSON.stringify(res.value))
          setCookie('token', res.value.token)
          this.$store.commit('toLogin', true)
          this.$store.commit('changeUserImg', res.value.userImage)
          this.lBoxShowChange(false)
          this.realName = res.value.realName
          this.department = res.value.department
          this.userImage = res.value.userImage
          this.username = ''
          this.password = ''
          this.$message({
            message: '登录成功',
            type: 'success'
          })
          if (!res.value.label) {
            this.$store.commit('changeShowLabels', true)
          }
        } else {
         // this.$message.error(`登录失败`)
          this.password = ''
        }
      })
    },
    codeLogin: function () {
      // if (!this.checkLogin()) {return}
      const prames = {
        code: this.userCode
      }
      ApiGetLoginInfoByCode(prames).then(res=>{
        if (res.code == 200) {
          setCookie('user', JSON.stringify(res.value))
          setCookie('token', res.value.token)
          this.$store.commit('toLogin', true)
          this.$store.commit('changeUserImg', res.value.userImage)
          this.lBoxShowChange(false)
          this.realName = res.value.realName
          this.department = res.value.department
          this.userImage = res.value.userImage
          this.username = ''
          this.password = ''
          this.$message({
            message: '登录成功',
            type: 'success'
          })
          if (!res.value.label) {
            this.$store.commit('changeShowLabels', true)
          }
        } else {
         // this.$message.error(`登录失败`)
          // this.password = ''
        }
      })
    },
    exit: function () {
      this.$confirm('确认要退出登录吗？')
      .then(_ => {
         removeCookie('token')
         removeCookie('user')
         removeCookie('headOffice')
         this.$store.commit('toLogin', false)
         this.$router.push('/')
      })
      .catch(_ => {})
    },
    getUserInfo: function () {
      const _user = getCookie('user')
      if (_user) {
        const user = JSON.parse(_user)
        this.realName = user.realName
        this.department = user.department
        this.userImage = user.userImage || this.userImage
        this.$store.commit('toLogin', true)
        this.$store.commit('changeUserImg', this.userImage)
      }
    },
    pointsOrder: function () {
      const pramas = {
        orderType: 0,
        detailId: this.pointsDetailId
      }
      ApiPointsOrder(pramas).then(res=>{
        console.log('res')
      })
    },
    handlPath: function () {
      this.navList = this.navList.map(item=>{
        return {...item, isCur: item.path == this.$route.path}
      })
    },
    toForget: function () {
      this.$store.commit('showLogin', false)
      this.$router.push('/ForGetPassword')
    }
  },
  watch: {
    isLogin: function () {
      this.getUserInfo()
    },
    '$route':'handlPath',
    pointsDetailId: function (oldVal, newVal) {
      this.pointsOrder()
    }
  },
  mounted: function () {
    this.userCode = this.$route.query.code || ''
    if (this.userCode) {
      this.codeLogin()
    } else{
      this.getUserInfo()
    }
    this.getLinks()
    this.handlPath()
    this.localHeadOffice = getCookie('headOffice') || 1
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Zcl/Zcl.vue